import Rx from 'ub_wrapped/rx';

import FontActions from './font-actions';

const fontActionsSubject = new Rx.Subject();
const stateChangedSubject = new Rx.Subject();

let currentState = {};
let activeElement;

const setActiveElement = (element) => {
  activeElement = element;

  fontActionsSubject.onNext({type: 'updateFormLabelStyles'});
};

stateChangedSubject.subscribe((newState) => {
  currentState = newState;
});

fontActionsSubject
  .subscribe((ev) => {
    const modelData = activeElement && activeElement.model;
    const newState = FontActions[ev.type](currentState, ev.value, modelData);

    stateChangedSubject.onNext(newState);
  });

export default {
  stateChangedSubject,
  fontActionsSubject,
  setActiveElement
};



// WEBPACK FOOTER //
// ./src/fonts/font-picker/form/form-field-label/state-controller.js